// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ROqVc","largestCol":"styles_largestCol__3QuBR","smallestCol":"styles_smallestCol__1TQm1"};